import { PropsWithChildren } from 'react';

export const GroupLabel = ({ children }: PropsWithChildren) => {
  return (
    <div className="sticky bg-base-white top-0 px-2 mb-0.5 text-xs font-bold text-gray-500 uppercase">
      {children}
    </div>
  );
};
